// Copyright (c) 2019 Deere & Company

import t from 'tcomb';

const PipIndicator = t.struct({
    color: t.String,
    status: t.String,
}, {
    name: 'PipIndicator',
    strict: true,
});

export const getDefaultState = () => new PipIndicator({
    color: '',
    status: '',
});

export default PipIndicator;
